import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import styled from "styled-components";
import { IBasketDetailsTable } from "../../types/financeTypes";

export const StyledDataGridHeader = styled(DataGrid)`
  && .css-yrdy0g-MuiDataGrid-columnHeaderRow {
    font-size: small;
    background-color: #f5f5f5;
  }
`;

interface ITableProps<T> {
  rows: T[];
  columns: GridColDef[];
  backgroundColor?: string;
}

const BasketDetailsTable: React.FC<ITableProps<IBasketDetailsTable>> = ({ rows, columns, backgroundColor }) => {
  return (
    <div style={{ height: 400, width: "100%" }}>
      <StyledDataGridHeader
        sx={{ backgroundColor: `${backgroundColor}` }}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
      />
    </div>
  );
};

export default BasketDetailsTable;
